/* LabCharge offer page: offer selection, unlockable perks, cart-permalink checkout,
   24h countdown, access gate, sticky buy bar. Vanilla JS, no dependencies. */
(function () {
  'use strict';

  var PERKS = ['shipping', 'warranty2', 'lifetime', 'priority'];
  var SEL = {
    card: 'border-green-500 bg-green-50/60 shadow-md',
    cardOff: 'border-gray-200 bg-white hover:border-gray-300 hover:shadow-sm',
    panel: 'bg-green-50', panelOff: 'bg-gray-50',
    radio: 'border-green-500 bg-green-500', radioOff: 'border-gray-300 bg-white'
  };

  /* ---------- tiny helpers ---------- */
  function all(root, sel) { return Array.prototype.slice.call(root.querySelectorAll(sel)); }
  function swap(el, remove, add) {
    if (!el) return;
    remove.split(' ').forEach(function (c) { if (c) el.classList.remove(c); });
    add.split(' ').forEach(function (c) { if (c) el.classList.add(c); });
  }
  function store(key, val) {
    try { localStorage.setItem(key, val); } catch (e) {}
    try { document.cookie = key + '=' + encodeURIComponent(val) + '; path=/; max-age=' + (60 * 60 * 24 * 30) + '; SameSite=Lax'; } catch (e) {}
  }
  function read(key) {
    var v = null;
    try { v = localStorage.getItem(key); } catch (e) {}
    if (v) return v;
    try {
      var m = document.cookie.match(new RegExp('(?:^|; )' + key.replace(/[.*+?^${}()|[\]\\]/g, '\\$&') + '=([^;]*)'));
      if (m) return decodeURIComponent(m[1]);
    } catch (e) {}
    return null;
  }
  function pad(n) { return (n < 10 ? '0' : '') + n; }

  /* ---------- per-page init ---------- */
  function init(root) {
    var d = root.dataset;
    var cfg = {
      cartUrl: d.cartUrl || '/cart',
      clearUrl: d.clearUrl || '/cart/clear',
      returnTo: d.returnTo || '/checkout',
      discount: (d.discount || '').trim(),
      v: { warranty2: d.vWarranty2 || '', lifetime: d.vLifetime || '', priority: d.vPriority || '', paid: d.vLifetimePaid || '' },
      key: d.key || 'offer',
      expired: false
    };

    var cards = all(root, '[data-lc-offer]');
    var state = { sel: null, paid: false };
    var buyButtons = all(root, '[data-lc-buy]');
    var sticky = root.querySelector('[data-lc-sticky]');
    var cta = root.querySelector('[data-lc-cta]');
    var addon = root.querySelector('[data-lc-addon]');
    var badge = root.querySelector('[data-lc-counter]');
    var counterTpl = badge ? badge.getAttribute('data-template') : '{n}/4 unlocked';

    function bind(name, text) {
      all(root, '[data-lc-bind="' + name + '"]').forEach(function (el) { el.textContent = String(text == null ? '' : text).replace(/<[^>]*>/g, ''); });
    }
    /* totals: selected offer + paid lifetime add-on (when ticked) */
    function money(tpl, cents) {
      return String(tpl || '').replace(/\d[\d.,]*/, (cents / 100).toFixed(2));
    }
    function refreshPrice() {
      var card = state.sel; if (!card) return;
      var base = parseInt(card.getAttribute('data-cents'), 10);
      var cmp = parseInt(card.getAttribute('data-compare-cents'), 10);
      var add = 0;
      if (state.paid && addon) {
        add = parseInt(addon.getAttribute('data-cents'), 10);
        if (!(add > 0)) { var m = ((addon.querySelector('[data-lc-addon-price]').getAttribute('data-paid-text') || '').match(/\+\s*[^\d]*(\d+(?:[.,]\d+)?)/) || [])[1]; add = m ? Math.round(parseFloat(m.replace(',', '.')) * 100) : 0; }
      }
      var price = card.getAttribute('data-price'), cmpTxt = card.getAttribute('data-compare'), cmpShort = card.getAttribute('data-compare-short');
      if (base > 0 && add > 0) {
        price = money(price, base + add);
        if (cmp > 0) { cmpTxt = money(cmpTxt, cmp + add); cmpShort = money(cmpShort, cmp + add); }
      }
      bind('price', price); bind('cta-price', price); bind('bar-price', price);
      bind('compare', cmpTxt); bind('bar-compare', cmpShort);
      all(root, '[data-lc-compare-wrap]').forEach(function (el) { el.hidden = !card.getAttribute('data-compare'); });
    }
    function unlockSet(card) {
      var o = {};
      (card.getAttribute('data-unlock') || '').split(',').forEach(function (k) { if (k) o[k] = true; });
      return o;
    }

    /* ----- selection ----- */
    function select(card, silent) {
      if (!card || card.disabled) return;
      state.sel = card;
      cards.forEach(function (c) {
        var on = c === card;
        c.setAttribute('aria-checked', on ? 'true' : 'false');
        c.style.transform = on ? 'scale(1.005)' : 'scale(1)';
        swap(c, on ? SEL.cardOff : SEL.card, on ? SEL.card : SEL.cardOff);
        swap(c.querySelector('[data-lc-panel]'), on ? SEL.panelOff : SEL.panel, on ? SEL.panel : SEL.panelOff);
        swap(c.querySelector('[data-lc-radio]'), on ? SEL.radioOff : SEL.radio, on ? SEL.radio : SEL.radioOff);
        var dot = c.querySelector('[data-lc-dot]'), bar = c.querySelector('[data-lc-bar]');
        if (dot) dot.classList.toggle('hidden', !on);
        if (bar) bar.classList.toggle('hidden', !on);
      });

      var u = unlockSet(card), n = 0;
      PERKS.forEach(function (k) {
        var row = root.querySelector('[data-lc-perk="' + k + '"]');
        var on = !!u[k] || (row && row.hasAttribute('data-lc-always'));
        if (row && on) n++;
        if (row) {
          row.classList.toggle('is-on', on);
          row.setAttribute('aria-label', on ? 'Unlocked' : 'Locked');
        }
      });
      if (badge) {
        var txt = counterTpl.replace('{n}', n).replace('{total}', badge.getAttribute('data-total') || '4');
        if (badge.textContent !== txt) {
          badge.textContent = txt;
          if (!silent) {
            badge.classList.remove('lc-badge-pop'); void badge.offsetWidth; badge.classList.add('lc-badge-pop');
          }
        }
      }

      /* Lifetime Warranty row (always shown above the button): ticking adds the paid product; where the offer already unlocks it, it shows as included */
      if (addon) {
        var incl = !!u.lifetime;
        addon.classList.toggle('is-included', incl);
        if (incl) state.paid = false;
        addon.setAttribute('aria-pressed', (incl || state.paid) ? 'true' : 'false');
        addon.setAttribute('aria-disabled', incl ? 'true' : 'false');
        var pe = addon.querySelector('[data-lc-addon-price]');
        if (pe) pe.textContent = incl ? pe.getAttribute('data-incl-text') : pe.getAttribute('data-paid-text');
      }

      bind('title', card.getAttribute('data-title'));
      refreshPrice();
      all(root, '[data-lc-compare-wrap]').forEach(function (el) { el.hidden = !card.getAttribute('data-compare'); });
      all(root, '[data-lc-ship-flag]').forEach(function (el) { el.hidden = !(u.shipping || d.shipAll === 'true'); });
    }

    cards.forEach(function (c) { c.addEventListener('click', function () { select(c); }); });
    var initial = root.querySelector('[data-lc-offer][aria-checked="true"]') || cards[0];
    select(initial, true);

    if (addon) {
      addon.addEventListener('click', function () {
        if (addon.classList.contains('is-included')) return;
        state.paid = !state.paid;
        addon.setAttribute('aria-pressed', state.paid ? 'true' : 'false');
        refreshPrice();
      });
    }

    /* ----- cart permalink: /cart/VARIANT:QTY,VARIANT:QTY?discount=CODE&return_to=/checkout ----- */
    function buildUrl() {
      var card = state.sel;
      if (!card) return null;
      var main = (card.getAttribute('data-variant') || '').trim();
      if (!/^\d+$/.test(main)) return null;
      var u = unlockSet(card), items = [main + ':1'];
      ['warranty2', 'lifetime', 'priority'].forEach(function (k) {
        if (u[k] && /^\d+$/.test(cfg.v[k])) items.push(cfg.v[k] + ':1');
      });
      if (!u.lifetime && state.paid && /^\d+$/.test(cfg.v.paid)) items.push(cfg.v.paid + ':1');
      var q = [];
      if (u.shipping && cfg.discount) q.push('discount=' + encodeURIComponent(cfg.discount));
      q.push('return_to=' + cfg.returnTo);
      return cfg.cartUrl.replace(/\/$/, '') + '/' + items.join(',') + '?' + q.join('&');
    }
    root.lcBuildUrl = buildUrl; // handy for testing in the console

    function buy() {
      if (cfg.expired) return;
      var url = buildUrl();
      if (!url) { window.alert('This offer is not available right now.'); return; }
      buyButtons.forEach(function (b) { b.setAttribute('aria-busy', 'true'); });
      /* clear any old cart so only this offer reaches checkout, then follow the permalink */
      var done = false;
      function go() { if (done) return; done = true; window.location.href = url; }
      try {
        fetch(cfg.clearUrl + '.js', { method: 'POST', credentials: 'same-origin' }).then(go, go);
      } catch (e) { go(); }
      setTimeout(go, 1500);
    }
    buyButtons.forEach(function (b) { b.addEventListener('click', buy); });

    /* ----- sticky buy bar ----- */
    var ctaVisible = true;
    function updateSticky() {
      if (!sticky) return;
      var show = !cfg.expired && !ctaVisible && window.pageYOffset > 200;
      sticky.classList.toggle('translate-y-full', !show);
      sticky.classList.toggle('opacity-0', !show);
      sticky.classList.toggle('translate-y-0', show);
      sticky.classList.toggle('opacity-100', show);
      if ('inert' in sticky) sticky.inert = !show;
    }
    if (sticky && cta && 'IntersectionObserver' in window) {
      new IntersectionObserver(function (e) { ctaVisible = e[0].isIntersecting; updateSticky(); }).observe(cta);
    }
    window.addEventListener('scroll', updateSticky, { passive: true });
    updateSticky();

    /* ----- countdown ----- */
    var timer = root.querySelector('[data-lc-timer]');
    if (timer && d.timerOn === 'true') startTimer();

    function expiryTime() {
      var ms = (parseFloat(d.hours) || 24) * 3600000, now = Date.now();
      var storeKey = 'lc_start_' + cfg.key, start = null;
      var raw = null;
      try { raw = new URLSearchParams(window.location.search).get(d.param || 't'); } catch (e) {}
      if (raw && /^\d{9,13}$/.test(raw)) {
        var n = parseInt(raw, 10);
        if (n < 1e12) n *= 1000;                 // seconds -> ms
        start = Math.min(n, now);                // a send time in the future can never extend the offer
        store(storeKey, String(start));
      } else {
        var saved = parseInt(read(storeKey), 10);
        if (saved > 0 && saved <= now) start = saved;
        if (!start) { start = now; store(storeKey, String(start)); }
      }
      return start + ms;
    }

    function startTimer() {
      var exp = expiryTime();
      var h = timer.querySelector('[data-lc-h]'), m = timer.querySelector('[data-lc-m]'), s = timer.querySelector('[data-lc-s]');
      var text = timer.querySelector('[data-lc-timer-text]');
      var expiredText = timer.getAttribute('data-expired-text');
      var iv;
      function tick() {
        var left = Math.max(0, Math.ceil((exp - Date.now()) / 1000));
        h.textContent = pad(Math.floor(left / 3600));
        m.textContent = pad(Math.floor((left % 3600) / 60));
        s.textContent = pad(left % 60);
        timer.classList.toggle('is-urgent', left > 0 && left <= 3600);
        if (left <= 0) {
          clearInterval(iv);
          cfg.expired = true;
          root.classList.add('is-expired');
          timer.classList.add('is-expired');
          if (text && expiredText) text.textContent = expiredText;
          buyButtons.forEach(function (b) { b.disabled = true; b.setAttribute('aria-disabled', 'true'); });
          updateSticky();
        }
      }
      tick();
      if (!cfg.expired) iv = setInterval(tick, 1000);
      document.addEventListener('visibilitychange', function () { if (!document.hidden && !cfg.expired) tick(); });
    }


    /* ----- stock scarcity block: simulated countdown (45-47, -1 every 20-25 s) or static real inventory ----- */
    var stocks = all(root, '[data-lc-stock]');
    if (stocks.length && stocks[0].getAttribute('data-mode') === 'simulated') {
      (function () {
        var D = stocks[0].dataset, cap = parseInt(D.cap, 10) || 99;
        var lo = parseInt(D.startMin, 10) || 45, hi = Math.max(lo, parseInt(D.startMax, 10) || lo);
        var floor = parseInt(D.floor, 10); if (isNaN(floor)) floor = 27;
        var dmin = (parseFloat(D.dropMin) || 20) * 1000, dmax = Math.max(dmin, (parseFloat(D.dropMax) || 25) * 1000);
        var key = 'lc_stock_' + cfg.key, left, saved = null;
        try { saved = JSON.parse(read(key)); } catch (e) {}
        if (saved && saved.left > 0 && saved.t && Date.now() - saved.t < 30 * 60000) {   // remembered for 30 minutes, then a fresh start
          left = Math.max(floor, saved.left - Math.floor((Date.now() - saved.t) / ((dmin + dmax) / 2)));
        } else {
          left = lo + Math.floor(Math.random() * (hi - lo + 1));
        }
        left = Math.max(left, Math.min(floor, lo));
        function fill(t, pct) { return String(t).replace(/\{left\}/g, left).replace(/\{cap\}/g, cap).replace(/\{claimed\}/g, pct); }
        function render() {
          var pct = Math.round((cap - left) * 100 / cap);
          stocks.forEach(function (el) {
            var lab = el.querySelector('[data-lc-stock-label]'), bar = el.querySelector('[data-lc-stock-bar]'), sub = el.querySelector('[data-lc-stock-sub]');
            if (lab) lab.textContent = fill(el.getAttribute('data-label') || '', pct);
            if (sub) sub.innerHTML = fill(el.getAttribute('data-sub') || '', pct);
            if (bar) bar.style.width = pct + '%';
          });
        }
        function persist() { store(key, JSON.stringify({ left: left, t: Date.now() })); }
        function next() {
          setTimeout(function () {
            if (cfg.expired) return;
            if (left > floor) { left--; render(); persist(); }
            if (left > floor) next();
          }, dmin + Math.random() * (dmax - dmin));
        }
        render(); persist(); next();
      })();
    }

    /* ----- stack sticky top bars (timer / stock) in the order they were dragged ----- */
    function stackTop() {
      var off = 0;
      all(root, '.lc-top').forEach(function (el) {
        if (window.getComputedStyle(el).position === 'sticky') { el.style.top = off + 'px'; off += el.offsetHeight; }
        else { el.style.top = ''; }
      });
    }
    stackTop();
    window.addEventListener('resize', stackTop);
    window.addEventListener('load', stackTop);
    if ('ResizeObserver' in window) { var topRO = new ResizeObserver(stackTop); all(root, '.lc-top').forEach(function (el) { topRO.observe(el); }); }

    /* ----- access gate ----- */
    var gate = root.querySelector('[data-lc-gate]');
    if (gate) {
      var hash = d.gateHash, gateKey = 'lc_gate_' + cfg.key;
      var form = gate.querySelector('form'), input = gate.querySelector('input'), err = gate.querySelector('[data-lc-gate-error]');
      function sha256(str) {
        if (!(window.crypto && crypto.subtle && window.TextEncoder)) return Promise.reject(new Error('nocrypto'));
        return crypto.subtle.digest('SHA-256', new TextEncoder().encode(str)).then(function (buf) {
          return Array.prototype.map.call(new Uint8Array(buf), function (b) { return ('0' + b.toString(16)).slice(-2); }).join('');
        });
      }
      form.addEventListener('submit', function (e) {
        e.preventDefault();
        var code = (input.value || '').trim().toLowerCase();
        sha256(code).then(function (h) {
          if (h === hash) {
            store(gateKey, hash);
            root.classList.add('lc-gate-ok');
            err.textContent = '';
          } else {
            err.textContent = gate.getAttribute('data-error');
            input.classList.remove('is-error'); void input.offsetWidth; input.classList.add('is-error');
            input.select();
          }
        }, function () { err.textContent = 'Please open this page in a modern browser over https.'; });
      });
      setTimeout(function () { if (!root.classList.contains('lc-gate-ok')) input.focus(); }, 50);
    }
  }

  function boot() { all(document, '[data-lc-root]').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
})();
